export enum TextFormattingMode {
  Default = 'Default',
  AdjustToScale = 'AdjustToScale',
}
